import { ExternalCalendar } from '@griply/types';

// The id tiebreak keeps same-named calendars in one order on both engines.
export const sortCalendarsByName = (
  calendars: ExternalCalendar[],
): ExternalCalendar[] =>
  [...calendars].sort(
    (a, b) =>
      (a.name || '').localeCompare(b.name || '') || a.id.localeCompare(b.id),
  );
